import React from 'react'
import { useDasBalanceContext } from '@did/das-app-context'
import { WithdrawListType } from '@did/das-balance-types'
import { Button } from '@did/das-balance-components'
import { Iconfont } from '@did/uikit'

export const WithdrawList: WithdrawListType = ({ className, list }) => {
  const { tt } = useDasBalanceContext()

  const onWithdraw = () => {}

  return (
    <div className="">
      <table className="table-auto w-full text-left">
        <thead>
          <tr>
            <th className="text-third-font-color text-sm font-normal leading-4 w-1/3 h-8 pr-8">
              Withdrawable Credit
            </th>
            <th className="text-third-font-color text-sm font-normal leading-4 w-1/3 h-8">
              Source
            </th>
            <th className="text-third-font-color text-sm font-normal leading-4 w-1/3 h-8 text-right">
              Action
            </th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td className="text-base leading-none font-semibold w-1/3 h-[70px]">
              100,000
            </td>
            <td className="w-1/3 h-[70px]">
              <span className="inline-flex items-center cursor-pointer">
                <Iconfont name="ethereum" className="mr-2" size="16" />
                Stripe
                <Iconfont name="arrow-right" color="#B0B8BF" size="16" />
              </span>
            </td>
            <td className="w-1/3 h-[70px]">
              <Button
                className="!rounded-lg float-right"
                black
                middle
                onClick={onWithdraw}
              >
                {tt('Withdraw')}
              </Button>
            </td>
          </tr>
          {list.map((row, index) => (
            <tr key={index}>
              <td className="border h-[70px]">{row.didPoint}</td>
              <td className="border h-[70px]">{row.source}</td>
              <td className="border h-[70px]">{row.action}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  )
}
